import { defineStore } from 'pinia'
import { useAuthStore } from './authStore'
import { useCallStore } from './callStore'
import { useTaskStore } from './taskStore'
import useLetsDialSocket from '../services/letsDialSocket/useLetsDialSocket'
import useLetsDialPhone from '../services/letsDialPhone/useLetsDialPhone'
import registerGlobalListeners from '../services/letsDialSocket/SocketGlobalEventListeners'
import registerGlobalPhoneListeners from '../services/letsDialPhone/PhoneEventListeners'
import { PhoneStatusTypes } from '@letsdial/phone'

export const useInitStore = defineStore({
  id: 'init',
  state: () => ({
    isMounted: false,
    globalListenersRegistered: false,
  }),
  actions: {
    load() {
      const authStore = useAuthStore()
      authStore.load()
    },
    async initialize() {
      const authStore = useAuthStore()
      const { socket } = useLetsDialSocket()
      const { phone } = useLetsDialPhone()

      if (!this.globalListenersRegistered) {
        registerGlobalListeners(socket)
        registerGlobalPhoneListeners(phone)
        this.globalListenersRegistered = true
      }

      if (socket.ws?.connected !== true) {
        socket.connect()
      }

      // We wait for socket connection to trigger phone connection in a coordinated way
      // but we can also trigger it here if auth is ready
      if (authStore.isAuthenticated && authStore.user?.id && authStore.extensionPassword) {
        if (
          phone.phoneStatus !== PhoneStatusTypes.REGISTERED &&
          phone.phoneStatus !== PhoneStatusTypes.REGISTERING
        ) {
          phone.connect(`${authStore.user.id + 10000}`, authStore.extensionPassword)
        }
      }
    },
    async mount() {
      if (this.isMounted) return
      this.isMounted = true

      const authStore = useAuthStore()
      const taskStore = useTaskStore()
      const callStore = useCallStore()
      
      await authStore.mount()
      taskStore.mount()
      callStore.mount()

      await this.initialize()
    },
    unmount() {
      this.isMounted = false
      const authStore = useAuthStore()
      const taskStore = useTaskStore()
      const callStore = useCallStore()
      authStore.unmount()
      taskStore.unmount()
      callStore.unmount()
    },
  },
})
